import PropTypes from 'prop-types';
import { formatCurrency } from '../../utils/CommonUtils';
import Countdown from './Countdown';
import Translations from '../../utils/Translations';
import { Component } from 'react';

class BonusTimer extends Component {
	css = {
		backgroundImage: 'url(' + this.props.backgroundImage + ')',
	};

	backgroundImage = this.props.backgroundImage;

	content = (
		<>
			<div className={this.backgroundImage ? 'feature-teaser-box__headline--large' : 'feature-teaser-box__headline--arrow-full-bonus'}>
				{Translations.get('VideoBonusBoxHeadLine')}
			</div>
			<div className="feature-teaser-box__offertitle">{Translations.get('TeaserBonusTileText3')}</div>
			<div className="feature-teaser-box__bonusvalue">{formatCurrency(this.props.bonusAmount)}</div>
			<div className="feature-teaser-box__offertitle">{Translations.get('VideoBonusBoxTitle')}</div>
			<Countdown className="h-center" countdown={this.props.countdown} countdownStartTime={this.props.countdownStartTime} />
		</>
	);

	render() {
		return (
			<div
					className={'feature-teaser-box -bonus -video h-text-align-center ' + (this.backgroundImage ? '-arrow-full-video' : '')}
					style={this.props.backgroundImage ? this.css : {}}
				>
					{this.backgroundImage && <div className={'feature-teaser-box__background'}></div>}
					{this.backgroundImage && <div className={'feature-teaser-box__text-wrapper'}>{this.content}</div>}
					{!this.backgroundImage && this.content}
				</div>
		);
	}
}

BonusTimer.propTypes = {
	bonusAmount: PropTypes.string.isRequired,
	countdown: PropTypes.number.isRequired,
	countdownStartTime: PropTypes.object,
	backgroundImage: PropTypes.string,
};

BonusTimer.defaultProps = {
	countdownStartTime: null,
};

export default BonusTimer;
